<era-device-scheduled-tasks-ui [scheduledTasks]="scheduledTasks$ | async"
                               (deleteEvent)="delete($event)">
</era-device-scheduled-tasks-ui>